import { render, staticRenderFns } from "./OpreateRecord.vue?vue&type=template&id=39a02974"
import script from "./OpreateRecord.vue?vue&type=script&lang=js"
export * from "./OpreateRecord.vue?vue&type=script&lang=js"
import style0 from "./OpreateRecord.vue?vue&type=style&index=0&id=39a02974&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports